/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedBuyerProtectionBox_viewer = {
    readonly isIntlFeaturesEnabled: boolean | null;
    readonly " $refType": "PdpSharedBuyerProtectionBox_viewer";
};
export type PdpSharedBuyerProtectionBox_viewer$data = PdpSharedBuyerProtectionBox_viewer;
export type PdpSharedBuyerProtectionBox_viewer$key = {
    readonly " $data"?: PdpSharedBuyerProtectionBox_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBuyerProtectionBox_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerProtectionBox_viewer",
  "selections": [
    {
      "alias": "isIntlFeaturesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "intlMVP2022"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"intlMVP2022\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '38f508407a0f5ddca7e32ad56af98ef4';
export default node;
